import { useSiteInfo } from '@contexts/SiteInfoContext';
import SiteMapping from '@configs/siteMapping';
import ErrorBoundary from '../common/ErrorBoundary';
import parseAnimateStyle from './parseAnimateStyle';
import { useTranslation } from 'next-i18next';
import React, {
    useState, useEffect, useRef,
} from 'react';
import { useWindowDimensions } from '../../hooks/windowDimension';
const TopBar = () => {
    const { siteName } = useSiteInfo();
    const { t } = useTranslation();
    const marqueeContainer = useRef(null);
    const { width } = useWindowDimensions();
    const [lines, setLines] = useState(1);
    const [animateStyle, setAnimateStyle] = useState('');

    useEffect(() => {
        if (width !== undefined) {
            const lineHeight = 22;
            const styles = getComputedStyle(marqueeContainer.current);
            const msgHeight = parseFloat(styles.height);
            const lines =  Math.round((msgHeight / lineHeight)/2)  ;
            setAnimateStyle(parseAnimateStyle(lines, lineHeight));
            setLines(lines);
        }
    }, [width])

    return (
        <ErrorBoundary>
            <div className="topbar">
                <div className="announce">
                    <div className="announce__content">
                        <style dangerouslySetInnerHTML={{ __html: animateStyle }}>
                        </style>
                        <div ref={(el) => { marqueeContainer.current = el }} className={`text marquee${lines}`}>
                            <span className="text">{t('lbl_CopySiteWarning')}</span>
                            <br />
                            <span className="text">{t('lbl_CopySiteWarning')}</span>
                        </div>
                    </div>

                </div>
            </div>
        </ErrorBoundary>
    );
};

export default TopBar;
